import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "components/common/button/Button"
import { InputExtensionType } from "types/form-types"

type InputExtensionPropsType = {
    icons?: InputExtensionType | InputExtensionType[],
    isFocused?: boolean
}

const InputExtensionItem = (extension: InputExtensionType) => {
    let render: React.ReactNode = <></>;
    if(typeof extension.onClick == 'function') {
        render = (
            <Button title={extension.title || extension.name} name={extension.name} className={extension.className} onClick={extension.onClick} theme="link" >
                <FontAwesomeIcon icon={extension.icon} />
            </Button>
        )
    } else {
        render = <FontAwesomeIcon icon={extension.icon} />
    }

    return render;
}

const InputExtension = (prop: InputExtensionPropsType) => {
    let render: React.ReactNode;
    if(Array.isArray(prop.icons)) {
        render = <>{
            prop.icons.filter(i => !i.hidden || !i.hidden(prop.isFocused)).map(i => {
                return <InputExtensionItem key={i.name} {...i} />;
            })
        }</>;
    } else if(prop.icons && (!prop.icons.hidden || !prop.icons.hidden(prop.isFocused))) {
        render = <InputExtensionItem {...prop.icons} />;
    } else {
        render = <></>;
    }
    return render; 
}

export default InputExtension
